import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "CityLevelModel",
  data: function data() {
    return {
      visible: false,
      loading: false,
      formData: {
        cityIds: []
      },
      rules: {
        cityIds: [{
          required: true,
          message: "请选择评级开启城市",
          trigger: "change",
          validator: function validator(rule, value, callback) {
            if (!value || value.length === 0) {
              callback(new Error("请选择评级开启城市"));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  props: {
    cities: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    commit: function commit() {
      var _this = this;
      this.loading = true;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.$api.setQuarterCityLevel({
            cityIds: _this.formData.cityIds
          }).then(function (res) {
            if (res.data) {
              _this.$message.success("设置成功");
            } else {
              _this.$message.error(res.msg);
            }
          }).finally(function () {
            _this.visible = false;
            _this.loading = false;
          });
        } else {
          _this.loading = false;
        }
      });
    },
    show: function show() {
      var _this2 = this;
      this.visible = true;
      this.$api.getQuarterOpenCity().then(function (res) {
        _this2.formData.cityIds = res.data || [];
      });
      this.$nextTick(function () {
        _this2.$refs.form && _this2.$refs.form.clearValidate();
      });
    }
  }
};